import Vue, { PropOptions } from "vue"

import scrollToSelfMixin from "~/mixins/shared/scrollToSelf"

export default Vue.extend({
  mixins: [scrollToSelfMixin],
  props: {
    pValidity: {
      required: false,
      default() {
        return undefined
      },
      type: [Boolean, undefined],
    } as PropOptions<boolean | undefined>,
    pIsValidating: {
      required: false,
      default() {
        return undefined
      },
      type: [Boolean, undefined],
    } as PropOptions<boolean | undefined>,
    pApplyValidity: {
      type: Boolean,
      required: false,
      default() {
        return true
      },
    },
  },
  data() {
    return {
      PRIVATE_VALIDITY: true,
      PRIVATE_IS_VALIDATING: false,
    }
  },
  computed: {
    validity(): boolean {
      return this.pValidity ?? this.PRIVATE_VALIDITY
    },
    isValidating(): boolean {
      return this.pIsValidating ?? this.PRIVATE_IS_VALIDATING
    },
  },
})
